
<div class="modal" tabindex="-1" role="dialog" [ngClass]="isShowModal ? 'open-modal' : 'close-modal'">
  <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
          <div class="modal-header title-container" [hidden]="true">
            <img
            (click)="hideModal()"
              *ngIf="!showSuccessDailog"
              class="close-logo"
              src="assets/locations/close.png"
              alt="..."
            />
            <h3>{{(heading | translate) ? ((heading | translate)): heading }}</h3>
          </div>
          <div class="modal-body">
            <div
            *ngIf="!showSuccessDailog && !showProgress"
            class="trackupload-modal-content trail-upload-region"
            appDragDropFileUpload
            (click)="fileField.click()"
            (fileDropped)="fileChange($event)"
          >
            <div for="fileField">
              <img class="upload-logo" src="assets/locations/file.png" alt="..." />
            </div>
            <div>
              <input type="file" #fileField (change)="fileChange($event)" accept=".gpx, .zip, .kml" />
              <span>{{'BP_EM_DRAG_DROP' | translate }} <strong
                  class="heightlight-color">{{'BP_CM_BROWSE_BTN_LBL' | translate }}</strong></span>
            </div>
            </div>
          <div class="trackupload-modal-content trail-upload-region" *ngIf="showProgress"             
          >
            <div for="fileField">
              <img class="upload-logo" src="assets/locations/file.png" alt="..." />
            </div>
            <div class="progress-bar">
              <app-progressbar
                [progress]="progress"
                *ngIf="showProgress"
              ></app-progressbar>
            </div>
          </div>
        
          <div class="successfull-content" *ngIf="showSuccessDailog">
            <div for="fileField">
              <img
                class="success-logo"
                src="assets/locations/icn_tick.png"
                alt="..."
              />
            </div>
            <div>
              <span class="upload-text">{{'BP_UPLOAD_COMPLETE_HEADER' | translate }}</span>
              <span class="redirect-text">{{'BP_REDIRECTING_NEXT_STEPS_MSG' | translate}}</span>
            </div>
          </div>
          </div>
      </div>
  </div>
</div>